/**
 * Copyright Highway9 Networks Inc.
 */

import { Hardware } from "~/types/Hardware";
import APIService from "./APIServices";
import { Product, ProductClassMapping } from "~/types/Product";
import { SKU } from "~/types/SKU";
import { ObjectReference } from "~/types/dataObject";

const hardwareAPI = new APIService<Hardware>("hardware");
const productAPI = new APIService<Product>("products");
const skuAPI = new APIService<SKU>("skus");

export type HardwareQuery = {
  tenantId?: string;
  serviceInstanceId?: string;
  hardwareType?: string;
  status?: string;
  id?: string;
}

type AssignedHardware = {
  tenantId: string;
  serviceInstanceId: string;
  hardwareType: string;
  hardwareId: string;
  leaseStartDate: number;
  leaseExpiryDate: number;
  paidResource: boolean;
  sku: ObjectReference;
  product?: ObjectReference;
}
type RevokeHardware= {
  tenantId: string;
  serviceInstanceId: string;
  hardwareType: string;
  hardwareId: string;
  sku: ObjectReference;
}

export type AssignHardwarePayload = {
  count: number;
  data: AssignedHardware[];
}

export type RevokeHardwarePayload = {
  count: number;
  data: RevokeHardware[];
}


export const hardwareService = {
  getHardwares: async (payload: HardwareQuery) => await hardwareAPI.post('query', payload) as unknown as Hardware[],
  createHardware: <T = Hardware>(data: T) => hardwareAPI.create(data as unknown as Hardware),
  deleteHardware: hardwareAPI.delete,
  editHardware: hardwareAPI.update,
  revokeHardware: (payload: HardwareQuery) => hardwareAPI.post('operations/revoke', payload) as unknown as Hardware[],
  assignHardware: (payload: AssignHardwarePayload) => hardwareAPI.post('operations/assign', payload),

  getProductClassMapping: async ( payload?: { filter: Record<string, any> }) => await productAPI.post('/productClass/query', payload ?? { filter: {} }) as unknown as ProductClassMapping[],  

  getProducts: async (payload?: { filter: Record<string, any> }) => await productAPI.post('query', payload ?? { filter: {} }) as unknown as Product[],
  createProduct: productAPI.create,
  deleteProduct: productAPI.delete,
  editProduct: productAPI.update,

  getSKUs: async (payload?: { filter: Record<string, any> }) => await skuAPI.post('query', payload ?? { filter: {} }) as unknown as SKU[],
  createSKU: skuAPI.create,
  deleteSKU: skuAPI.delete,
  editSKU: skuAPI.update,
};
